import { MeetingsSchedule } from "@api/models/meetings-schedule/MeetingsSchedule";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { WebConferenceRepository } from "@api/repositories/WebConferenceRepository";
import { DateTime } from "luxon";
import { AppointmentDataLoaderInterface } from "./AppointmentDataLoader";
import { scheduleSchemaId } from "@share/meetings-schedule/types/SchemaIds";
import VueRouter from "vue-router";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { Store } from "vuex";

import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName"
import { showAccessErrorModal } from "@share/web-conferences/helpers/ErrorModal";
import { WebConferenceErrorCode } from "@api/enums/errors/WebConference";
import { MeetingsSlotFabricInterface } from "@share/meetings-schedule/helpers/MeetingsSlotFabric";

export class AppointmentService {

    memberSlot?: MScheduleSlot = undefined;
    slots: MScheduleSlot[] = []
    schedule?: MeetingsSchedule = undefined;

    constructor(
        private dataLoader: AppointmentDataLoaderInterface,
        private webConferenceRepository: WebConferenceRepository,
        private slotFabric: MeetingsSlotFabricInterface,
        private router: VueRouter,
        private store: Store<any>,
        private scheduleId: string,
        private userId: number) {}

    async loadData(isAdmin: boolean, scheduleId: string) {
        if (scheduleId) {
            this.scheduleId = scheduleId
        }

        this.schedule = await this.loadSchedule(this.scheduleId);

        const isSpeaker = this.schedule?.userIds?.includes(this.userId);

        if(!isAdmin && !isSpeaker) {
            //только для участника
            const slot = await this.dataLoader.loadSlotByUserId(this.scheduleId, this.userId);

            if (!slot) {
                this.showNotFoundAlert();
            }
            else {
                if (DateTime.local() > slot.endAt) {
                    this.showSlotIsEndedAlert();
                }
                else {
                    this.memberSlot = slot;
                }
            }
        }
        else {
            await this.updateSlots();
        }
    }

    async loadSchedule(scheduleId: string) {
        return await this.dataLoader.loadSchedule(scheduleId);
    }

    async updateSlots() {
        const existingSlots = await this.dataLoader.loadSlots(this.scheduleId) || [];
        this.slots = this.schedule ? this.slotFabric.createSlots(this.schedule, existingSlots) : [];
    }

    async banUser(userId: number) {
        return this.webConferenceRepository.ban(scheduleSchemaId, this.scheduleId, userId)
    }

    private async showNotFoundAlert() {
        await showAccessErrorModal(WebConferenceErrorCode.scheduleNotFound);
        this.redirectToSchedule();
    }

    private async showSlotIsEndedAlert() {
        await showAccessErrorModal(WebConferenceErrorCode.wrongTime);
        this.redirectToSchedule();
    }

    redirectToSchedule() {

        this.store.dispatch("miniPlayer/setShowPlayer", false);
        this.store.dispatch("backgroundView/updateBroadcastQue",
            { viewName: BackgroundViewName.appointment, showPlayer: false, id: this.schedule }
        )

        this.router.push({
            name: RouteNamesEnum.meetingsSchedule
        });
    }
}